import { ErrorBoundary } from 'components/Errors/ErrorBoundary';
import LoadingScreen from 'components/LoadingScreen';
import React, { Fragment, Suspense } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  CardSubtitle,
} from 'reactstrap';

export type PageLayoutProps = {
  children: React.ReactNode;
  id?: string;
  heading?: React.ReactNode;
  subheading?: React.ReactNode;
  description?: React.ReactNode;
  count?: number;
  footerContents?: React.ReactNode | React.ReactNode[];
  className?: string;
  filteringOptions?: React.ReactNode;
};

const PageLayout = ({
  id,
  heading,
  subheading,
  children,
  description,
  footerContents,
  className,
  filteringOptions,
}: PageLayoutProps) => {
  return (
    <ErrorBoundary>
      <div id={id} className={`container-fluid p-0 ${className}`}>
        <Card className="mb-0">
          <CardHeader>
            <Row>
              {/* First column: fixed width on md+, full on xs */}
              <Col xs="12" md="3" className="mb-2">
                {typeof heading === 'string' ? (
                  <>
                    <CardTitle>
                      <h4>{heading}</h4>
                    </CardTitle>
                  </>
                ) : (
                  heading
                )}
                {subheading && <CardSubtitle>{subheading}</CardSubtitle>}
              </Col>
              {filteringOptions && (
                /* Second column: auto-expanding on md+, full on xs */
                <Col xs="12" md className="text-right" style={{ zIndex: 1001 }}>
                  {filteringOptions}
                </Col>
              )}
            </Row>
          </CardHeader>
          <CardBody>
            <Suspense fallback={<LoadingScreen />}>
              {description && (
                <Row>
                  <Col>{description}</Col>
                </Row>
              )}
              <Row className="mt-2">
                <Col>{children}</Col>
              </Row>
            </Suspense>
          </CardBody>
          {footerContents && (
            <CardFooter>
              <Suspense fallback={<LoadingScreen />}>
                {Array.isArray(footerContents)
                  ? footerContents.map((content, index) => (
                      <Fragment key={index}>{content}</Fragment>
                    ))
                  : footerContents}
              </Suspense>
            </CardFooter>
          )}
        </Card>
      </div>
    </ErrorBoundary>
  );
};

export default PageLayout;
